<script setup lang="ts">
withDefaults(
  defineProps<{
    additionalStoreOptions?: { value: number; label: string }[]
  }>(),
  {
    additionalStoreOptions: () => []
  }
)

const modelValue = defineModel<number[]>({ default: () => [] })

const { t } = useI18n()
</script>

<template>
  <div class="space-y-1.5 text-left">
    <label class="block text-sm font-medium text-foreground">
      {{ t('pages.customer.audiences.storeField.label') }}
    </label>
    <MultiSelectStores
      v-model="modelValue"
      :has-label="false"
      :show-all-selected-text="false"
      class="sm:w-full"
      :additional-store-options="additionalStoreOptions"
    />
    <p class="text-xs text-foreground-secondary">
      {{ t('pages.customer.audiences.storeField.hint') }}
    </p>
  </div>
</template>
